import React from "react";
import Resources from "../../../types/Resources";
import { Modal } from "react-bootstrap";
import InformationAlert from "../../Common/InformationAlert";
import Button from "../../Common/Button";

type AcceptUnsavedChangesModalProps = {
    show: boolean;
    onAccept: () => void;
    onUpdate: () => void;
    onHide: () => void;
    resources: Resources;
};

function AcceptUnsavedChangesModal({ show, onAccept, onUpdate, onHide, resources }: AcceptUnsavedChangesModalProps) {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("PermitHasUnsavedChanges")}</h1>
            </Modal.Header>
            <Modal.Body>
                <InformationAlert>{resources.get("PermitHasUnsavedChangesText")}</InformationAlert>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button onClick={onUpdate}>{resources.get("Update")}</Button>
                <Button onClick={onAccept} variant="danger">
                    {resources.get("Accept")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AcceptUnsavedChangesModal;
